module.exports = __webpack_public_path__ + "img/trade.585c36ee.png";